import api from '@/libs/axios'

export default {
  async getList(params) {
    let response = await api.get('/admin/earns/configs', { params })
    return response
  },
  async create(payload) {
    const response = await api.post('/admin/earns/configs', payload)
    return response.data.data.new_document || null
  },
  async update(payload) {
    let response = await api.put('/admin/earns/configs', payload)
    return response
  },
  async delete(payload) {
    const response = await api.delete('/admin/earns/configs', {
      data: payload,
    })
    return response
  },
}
